import { storage } from "./firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

export const uploadProfileImage = async (file: File, clienteId: string, type: "avatar" | "banner"): Promise<string> => {
  const storageRef = ref(storage, `clientes/${clienteId}/profileImages/${type}/${file.name}`);
  await uploadBytes(storageRef, file);
  const downloadURL = await getDownloadURL(storageRef);
  return downloadURL;
};

export const uploadFuncionarioImage = async (file: File, clienteId: string, funcionarioId: string): Promise<string> => {
  const storageRef = ref(storage, `clientes/${clienteId}/funcionarios/${funcionarioId}/${file.name}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};
